// extracted by mini-css-extract-plugin
export var section = "styles-module--section--3nQth";
export var title = "styles-module--title--2gAFG";
export var slideStyle = "styles-module--slideStyle--3DKw2";
export var slideStyleTextWrap = "styles-module--slideStyleTextWrap--sLkot";
export var categories = "styles-module--categories--JLrgE";